import React from 'react'
import { Instagram, Locate, PhoneCall } from 'lucide-react'

function Footer() {
  return (
    <div id='Footer' className='bg-gradient-to-tl rounded-3xl from-[#A0D9C1] flex flex-col md:flex-row 
    justify-between my-8 mx-auto md:min-h-[82vh] overflow-hidden w-[90%] md:w-[80%]'>
      
      {/* Left Content Section */}
      <div className='flex flex-col gap-4 md:gap-6 p-6 md:p-8 md:pl-16 md:w-1/2 mt-8 md:mt-24'>
        <div className='flex flex-col gap-2 text-center md:text-left'>
          <h1 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold signika'>Subscribe to Our</h1>
          <h1 className='text-xl sm:text-2xl md:text-3xl lg:text-5xl font-bold alata'>Newsletter & Get Benefits</h1>
        </div>
        
        <p className='text-gray-600 text-sm sm:text-base md:text-lg text-center md:text-left'>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit
        </p>
        
        {/* Email Input and Subscribe Button */}
        <div className='flex flex-col sm:flex-row gap-4 mt-4'>
          <input 
            type='text' 
            placeholder='Enter Your Email' 
            className='w-full sm:w-[300px] md:w-[350px] lg:w-[400px] rounded-xl p-3 sm:p-4 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[#16B97A] text-sm sm:text-base'
          />
          <button className='bg-[#FFA300] w-full sm:w-auto hover:bg-[#16B97A] hover:scale-105 transition-all duration-500
          text-white px-6 py-3 sm:px-8 sm:py-4 font-semibold text-sm sm:text-base'
          style={{
            borderTopLeftRadius: '10px',
            borderBottomRightRadius: '30px'
          }}
          >
            Subscribe
          </button>
        </div>

        {/* Contact Information */}
        <div className='mt-6 md:mt-12'>
          <h3 className='font-semibold text-gray-700 mb-4 text-center md:text-left text-lg'>You can Contact us at</h3>
          <div className='flex flex-col gap-3 text-gray-600'>
            <div className='flex items-center justify-center md:justify-start gap-2'>
              <PhoneCall size={18} className='text-[#16B97A] flex-shrink-0'/>
              <p className='font-medium text-sm sm:text-base'>123-456-7890</p>
            </div>
            <div className='flex items-center justify-center md:justify-start gap-2'>
              <PhoneCall size={18} className='text-[#16B97A] flex-shrink-0'/>
              <p className='font-medium text-sm sm:text-base'>123-456-7890</p>
            </div>
            <div className='flex gap-4 mt-2 justify-center md:justify-start'>
              <div className='flex items-center gap-2'>
                <Instagram size={18} className='text-[#16B97A] flex-shrink-0'/>
                <span className='font-medium text-sm sm:text-base'>Instagram</span>
              </div>
              <div className='flex items-center gap-2'>
                <Instagram size={18} className='text-[#16B97A] flex-shrink-0'/>
                <span className='font-medium text-sm sm:text-base'>TikTok</span>
              </div>
            </div>
            <div className='flex items-center justify-center md:justify-start gap-2 mt-4'>
              <Locate size={18} className='text-[#16B97A] flex-shrink-0'/>
              <p className='font-medium text-sm sm:text-base'>Nairobi, Kenya</p>
            </div>
          </div>
        </div>
      </div>

      {/* Right Image Section */}
      <div className='md:w-1/2 flex justify-center items-center md:items-end mt-6 md:mt-0 p-4'>
        <img 
          src='/image/ContactPage.png' 
          alt='Contact Illustration'
          className='w-full max-w-md md:max-w-none h-auto object-contain md:object-cover'
        />
      </div>
    </div>
  )
}

export default Footer